<template>
  <div class="container">
    <div class="header"><img :src="$store.state.config.header" class="img"></div>
    <div class="content">
      <div class="main-body">
        <ul class="menu-list active">
          <li class="menu-item">
            <router-link class="back-btn" :to="{path: '/', query: {tt: $route.query.tt}}">奖项投票<span class="img-icon"></span></router-link>
          </li>
          <li class="menu-item">
            <router-link class="back-btn" :to="{path: '/company', query: {tt: $route.query.tt}}">公司投票<span class="img-icon"></span></router-link>
          </li>
        </ul>
        <div class="main-wrapper">
          <div class="main-content">
            <div class="line-height"><span>&nbsp;</span></div>
            <div class="intro">
              <p v-html="introduction"></p>
            </div>
            <div class="presents-box">
              <div v-if="has_category">
                <div v-for="item in categories">
                  <div class="menu-label">{{item.name}}</div>
                  <ul class="presents-lists">
                    <li class="presents-item" v-for="data in item.rewards">
                      <router-link :to="{path: 'list', query: {reward_id: data.reward_id, tt: $route.query.tt}}">
                        <div class="item-title">{{data.name}}</div>
                        <div class="item-arrow">&nbsp;</div>
                        <div class="clearfix"></div>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
              <div v-else>
                <ul class="presents-lists">
                  <div v-for="item in rewards" v-if="item.companies.length != 0">
                  <p style="margin-left: 20px;" :id="item.first_char" :ref="item.first_char">{{item.first_char}}</p>
                  <li class="presents-item" v-for="data in item.companies">
                    <router-link :to="{path: 'list_c', query: {company_name: data, tt: $route.query.tt}}">
                      <div class="item-title">{{rewards[rewards.length - 1].companies.length == 0? '': company_code[data].code}} {{data}}</div>
                      <div class="item-arrow">&nbsp;</div>
                      <div class="clearfix"></div>
                    </router-link>
                  </li>
                  </div>
                </ul>
                <div v-if="showLetter" class="centerLetter"><strong>{{currentLetter}}</strong></div>
                <div class="letterList" v-show="false">
                  <a v-for="letter in rewards"  style="display: block;font-size: 14px;margin-top: 1px" @click="jumper(letter.first_char)"><span>{{letter.first_char}}</span></a>
                  <a style="display: block" @click="jumper('#')">#</a>
                </div>
              </div>
            </div>
            <div class="footer"><img :src="$store.state.config.footer"></div>
          </div>
        </div>
      </div>
    </div>
    <v-loading v-show="status"></v-loading>
  </div>
</template>

<script>
import $ from 'jquery'

import Load from '@/components/Loading'
import shareInfo from '@/assets/js/weixinShare.js'

export default {
  name: 'HelloWorld',
  components: {
    'v-loading': Load
  },
  data () {
    return {
      showLetter: false,
      currentLetter: 'A',
      status: true, //loading状态
      introduction: '',
      has_category: false,
      title: '',
      rewards:[],
      categories:[],
      company_code: {}
    }
  },
  created() {
    let that = this;
    
    document.body.scrollTop = 0;
    $.ajax({
      type: 'get',
      url: that.$store.state.Host+'/v/votes/show_companies_with_pinyin?vote_identify='+that.$route.query.tt,
      success: function(res) {
        that.title = res.title;
        that.introduction = res.introduction;
        that.has_category = res.has_category;
        that.rewards = res.ret;
        that.categories = res.categories;
        that.company_code = res.company_infos;
        
        //longding
        that.status = false;
      }
    })

  },
  mounted() {
    let that = this;

    setTimeout(function() {
      // 分享调用
      shareInfo.init({title:that.$store.state.config.title,desc:that.$store.state.config.share_desc,shareURL: location.href,img:that.$store.state.config.share});
    }, 2000);
  },
  methods: {
    jumper(key){
      let that = this;

      that.currentLetter = key;
      if(key=='#') {
        $(window).scrollTop(0);
        return;
      } else {
        that.letter = key; 

        //点击侧边字母后屏幕中间的字母也显示,500毫秒隐藏
        if(that.showLetter == false) {
          that.showLetter = true;
          setTimeout(function() {
            that.showLetter = false;
          }, 500)
        } else {
          that.showLetter = false;
        }

        var el = document.getElementById(key);
        if(el){
          var scrollPosition = el.offsetTop;
          $(window).scrollTop(scrollPosition);
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Index_company.vue